
import { InvestigatorFormData } from '@/types/investigator';

export const initialFormData: InvestigatorFormData = {
  details: {
    name: '',
    age: '',
    occupation: '',
    residence: '',
    birthplace: '',
    avatar: undefined,
    maxSkillCapacity: 75, // Default to 75
  },
  characteristics: {
    strength: 0,
    dexterity: 0,
    intelligence: 0,
    constitution: 0,
    appearance: 0,
    power: 0,
    size: 0,
    education: 0,
    luck: 0,
    hitPoints: 0,
    sanity: 0,
    magicPoints: 0,
    movementRate: 0,
    damageBonus: '',
    build: 0,
  },
  characteristicsMethod: 'quickfire',
  quickfireAssignments: {},
  occupationSkills: {},
  personalSkills: {},
  specializationInputs: {},
  backstory: {
    ideology: '',
    significantPeople: '',
    meaningfulLocations: '',
    meaningfulObjects: '',
    traits: '',
    personalDescription: '',
    injuriesScars: '',
    phobiasManias: '',
    treasuredPossessions: '',
    encountersWithStrangeEntities: '',
  },
  equipment: {
    weapons: [],
    items: '',
  },
  currentStep: 1,
  era: '1920s',
  socialClass: undefined,
  occupationalBand: undefined,
  pulpMode: false,
  pulp: {
    archetype: '',
    talents: [],
    archetypeBonusAllocations: {},
    currentLuck: undefined,
    gadgets: [],
    psychicSkills: {},
  },
};
